import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { Fragment } from 'react';

import {
  ByggType,
  JaNeiVetIkke,
  PlasseringAvEnhetIByggVertikalt
} from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

import { HarOppvarmetKjellerRadio } from './harOppvarmetKjellerRadio';
import { TilliggendeRomSelect } from './tilliggendeRomSelect';

export const HarKjellerRadio = () => {
  const { register, watch, formState } = useOmBoligenFormContext();
  const { t } = useTranslation();

  const byggType = watch('bygginfo.byggtype');
  const hasBasement = watch('bygginfo.hasBasement');
  const verticalPlacement = watch('bygginfo.verticalPlacement');

  if (
    byggType === ByggType.Leilighet &&
    verticalPlacement != null &&
    verticalPlacement !== PlasseringAvEnhetIByggVertikalt.NedersteEtasje
  ) {
    return null;
  }

  const error = formState.errors.bygginfo?.hasBasement?.message;

  return (
    <Fragment>
      <Fieldset>
        <Fieldset.Legend>{t('register.bygningsdetaljer.harBoligenKjeller.label')}</Fieldset.Legend>
        <Fieldset.Description>
          {t('register.bygningsdetaljer.harBoligenKjeller.information')}
        </Fieldset.Description>
        <Radio
          {...register('bygginfo.hasBasement', {
            required: t('register.bygningsdetaljer.harBoligenKjeller.error'),
            shouldUnregister: true
          })}
          label={t('register.ja')}
          value={JaNeiVetIkke.Ja}
          aria-invalid={!!error}
        />

        <Radio
          {...register('bygginfo.hasBasement', {
            required: t('register.bygningsdetaljer.harBoligenKjeller.error'),
            shouldUnregister: true
          })}
          label={t('register.nei')}
          value={JaNeiVetIkke.Nei}
          aria-invalid={!!error}
        />
        {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
      </Fieldset>

      {hasBasement === JaNeiVetIkke.Ja && <HarOppvarmetKjellerRadio />}
      {hasBasement === JaNeiVetIkke.Nei && <TilliggendeRomSelect />}
    </Fragment>
  );
};
